import { render, staticRenderFns } from "./EasyOrdersTableSection.vue?vue&type=template&id=7095176a&scoped=true"
import script from "./EasyOrdersTableSection.vue?vue&type=script&lang=js"
export * from "./EasyOrdersTableSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7095176a",
  null
  
)

export default component.exports